import React from "react";

import { CartProductOptions } from "./CartProductOptions";
import { CartProductQuantity } from "./CartProductQuantity";

export const CartGridProduct = ({ item, settings }) => {
  const showVariantOptions = false;

  if (!item) {
    return false;
  }

  const size = item.options_with_values.find(
    (option) => option.name.toLowerCase() === "fragrance",
  );
  const line_item_price = item.price / 100;
  const show_total_price = true;
  // @ts-ignore
  const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
  let totalDiscount = 0;
  if (item.discounts) {
    item.discounts.forEach((discount) => {
      totalDiscount += discount.amount;
    });
  }
  return (
    <div className="product-thumb-wrapper flex gap-4">
      <a href={item.url} title={item.title} className="w-[96px] h-[92px] lg:w-[118px] lg:h-[135px] shrink-0">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </a>

      <div className="product-details justify-between max-lg:grow">
        <div className="product-details__inner">
          <div className={`product-details__inner-top flex gap-2 justify-between`}>
            <a href={item.url} title={item.product_title} className="product-title">
              {item.product_title}
            </a>

            <div className="product-price">
              <div className={"flex justify-end"}>
                <div className={"flex flex-cols"}>
                  {!show_total_price ? (
                      <>
                        <p className={`b3 font-normal`}>
                          {currencySymbol + line_item_price.toFixed(2)}
                        </p>
                        {item.product?.compare_at_price > 0 && (
                            <p className={`max-lg:text-xs font-normal`}>
                              {currencySymbol + item.product?.compare_at_price / 100}
                            </p>
                        )}
                      </>
                  ) : (
                      <div className={'flex flex-col text-right'}>
                        <p className={`b3 font-normal`}>

                          {currencySymbol + (line_item_price).toFixed(
                              2,
                          )}
                        </p>
                        {item.product?.compare_at_price && item.discounts.length <= 0 && (
                            <p className={`max-lg:text-xs font-normal`}>

                              {currencySymbol}
                              {
                                ((item.product?.compare_at_price * item.quantity) / 100).toFixed(2)
                              }
                            </p>
                        )}
                        {!item.product?.compare_at_price && item.discounts.length > 0 && (
                            <p className={`max-lg:text-xs font-normal line-through text-[#BBBBBD]`}>

                              {currencySymbol}
                              {(item.original_line_price  / 100)}
                            </p>
                        )}
                      </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {size && (
            <div className={"brs mt-1"}>{size?.value}</div>
          )}

          <div className={`product-details__inner-info`}>
            {item.selling_plan_allocation && (
              <div className="product-selling-plan brs flex gap-1 mt-2 max-lg:items-center">


                <span>{item.selling_plan_allocation.selling_plan.name}</span>
              </div>
            )}

            <div className={'discounts_applied'}>
              {item.discounts.map((discount, id) => {
                return (
                    <React.Fragment key={id}>
                      <p className={"brs text-[#394E47]"}>
                        {discount.title}</p>
                    </React.Fragment>
                );
              })}
            </div>

            {showVariantOptions && (
              <div className="product-options b3">
                {CartProductOptions(item.options_with_values)}
              </div>
            )}
          </div>
        </div>

        <div
            className="flex errors b4 my-0"
            style={{ padding: 0 }}
            data-ajax-cart-errors={`${item.key}`}
        ></div>

        <div>
          <CartProductQuantity item={item} settings={settings} />
        </div>
      </div>
    </div>
  );
};
